<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-import`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M31 4a1 1 0 011 1v2a1 1 0 01-1 1H8v32h23a1 1 0 011 1v2a1 1 0 01-1 1H6a2 2 0 01-2-2V6a2 2 0 012-2h25zM17.513 22.436l7.778-7.778a1 1 0 011.32-.084l.095.084 1.414 1.414a1 1 0 01.083 1.32l-.083.094-4.602 4.601 18.573-.082c.52.002.942.39.998.888l.006.116-.008 1.894a1 1 0 01-.88.989l-.115.007-18.207.08 4.235 4.235a1 1 0 01.083 1.32l-.083.094-1.414 1.414a1 1 0 01-1.32.084l-.095-.084-7.778-7.778a2 2 0 01-.117-2.701l.117-.127 7.778-7.778-7.778 7.778z"/></svg>
</template>
<script>

export default {
  name: 'IconImport',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
